import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag } from 'antd';

import { pageSectionTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

const height = window.innerHeight * .74;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const columnDefs = [
    { headerName: 'Lab', field: 'labName'},
    { headerName: 'Total Due', field: 'totalDue',  type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
];

class LabDueGrid extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    countTag = () => {
        if (this.store.isDone) {
            return (
                <Tag color="#108ee9">Total Due {this.store.branchTotal}</Tag>
            )
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const referrerId = selectedRows[0].refId;
        const branchId = selectedRows[0].branchId;

        this.store.selectLab(branchId, referrerId);
    }

    render() {

        const receivables = this.store.labDues;
        const branchName = this.store.selectedBranch

        return (
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(branchName)} tags={this.countTag()}>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={receivables}
                        rowSelection={'single'}
                        columnDefs={columnDefs}
                        onSelectionChanged={this.onSelectionChanged}>
                    </AgGridReact>
                </div>
            </PageHeader>
        )
    }
}

export default observer(LabDueGrid)
